import { Chakra } from "@airhelp/react-ui-components";
import PropTypes from "prop-types";

const { DrawerBody, DrawerFooter } = Chakra;

const MobileMenuContent = ({ headerButtons, menuItems }) => (
  <>
    <DrawerBody px={10} mt={20} fontSize={{ base: 18, lg: 16 }}>
      {menuItems}
    </DrawerBody>
    {headerButtons && (
      <DrawerFooter flexDirection="column" p={10} boxShadow="0px 8px 32px rgba(45, 60, 77, 0.1)">
        {headerButtons}
      </DrawerFooter>
    )}
  </>
);

export default MobileMenuContent;

MobileMenuContent.propTypes = {
  menuItems: PropTypes.node,
  headerButtons: PropTypes.node,
};

MobileMenuContent.defaultProps = {
  menuItems: "",
  headerButtons: "",
};
